module.exports = __webpack_public_path__ + "static/media/FSDLogoSight.2baf23fb.mp4";